import { useMemo } from 'react'

const useHourlyTicketTimeFields = () => (
  useMemo(() => ([
    {
      source: 'regular_time_in_hours',
      label: 'regular_time_in_hours',
      required: true,
    },
    {
      source: 'overtime_in_hours',
      label: 'overtime_in_hours',
      required: false,
    },
    {
      source: 'doubletime_in_hours',
      label: 'doubletime_in_hours',
      required: false,
    },
  ]),[])
);

export default useHourlyTicketTimeFields
